export const TUTORIAL_TRANSLATIONS = {
  en: {
    'tutorial.controls.progress': 'Step {current} of {total}',
    'tutorial.controls.back': 'Back',
    'tutorial.controls.next': 'Next',
    'tutorial.controls.finish': 'Finish',
    'tutorial.controls.skip': 'Skip tutorial',
    'tutorial.controls.pause': 'Pause',
    'tutorial.controls.dismiss': 'Dismiss tutorial',
    'tutorial.controls.resume': 'Resume tutorial',
    'tutorial.controls.restart': 'Restart',
    'tutorial.controls.replay': 'Replay',
    'tutorial.controls.start': 'Start',
    'tutorial.controls.unavailable': 'Not available yet',
    'tutorial.controls.closeLabel': 'Dismiss this tutorial',
    'tutorial.controls.cardLabel': 'Product tutorial',
    'tutorial.center.title': 'Guided tutorials',
    'tutorial.center.help': 'Replay any product tour or continue a paused tutorial.',
    'tutorial.center.complete': 'Completed',
    'tutorial.center.paused': 'Paused',
    'tutorial.center.skipped': 'Skipped',
    'tutorial.center.dismissed': 'Dismissed',
    'tutorial.center.active': 'In progress',
    'tutorial.center.new': 'Not started',
    'tutorial.center.loading': 'Loading tutorial progress…',
    'tutorial.center.contextRequired': 'Available when this feature is on screen',
    'tutorial.center.restartAll': 'Restart all tutorials',

    'tutorial.landing.name': 'Product introduction',
    'tutorial.landing.hero.title': 'Welcome to AWN AdPulse',
    'tutorial.landing.hero.body': 'Turn brand knowledge into campaign strategy, copy, images, and video from one connected workspace.',
    'tutorial.landing.intro.title': 'One connected creative system',
    'tutorial.landing.intro.body': 'The platform keeps your brand context, campaign brief, production tools, and review workflow together.',
    'tutorial.landing.features.title': 'Explore the core capabilities',
    'tutorial.landing.features.body': 'These modules cover grounded brand knowledge, campaign generation, creative formats, and measurable quality.',
    'tutorial.landing.workflow.title': 'Follow a clear path to launch',
    'tutorial.landing.workflow.body': 'Build the brand foundation, compose a campaign, refine the assets, then review performance.',
    'tutorial.landing.contact.title': 'Get help from the team',
    'tutorial.landing.contact.body': 'Use this form to request access, discuss a rollout, or arrange a guided demonstration.',

    'tutorial.workspace.name': 'Campaign Studio workflow',
    'tutorial.workspace.intro.title': 'Your campaign workspace',
    'tutorial.workspace.intro.body': 'Compose a grounded brief and generate a complete campaign without leaving this page.',
    'tutorial.workspace.brief.title': 'A focused three-step brief',
    'tutorial.workspace.brief.body': 'The wizard keeps brand inputs, audience choices, and production settings in manageable groups.',
    'tutorial.workspace.brand.title': 'Step 1: Brand and product',
    'tutorial.workspace.brand.body': 'Choose a saved Brand Hub profile or enter a brand manually. Select this step to review its fields.',
    'tutorial.workspace.audience.title': 'Step 2: Audience and value',
    'tutorial.workspace.audience.body': 'Define who the campaign should reach, the benefits to emphasize, and any offer or visual reference.',
    'tutorial.workspace.output.title': 'Step 3: Strategy and output',
    'tutorial.workspace.output.body': 'Choose the goal, tone, platform, art direction, AI model, and optional video output.',
    'tutorial.workspace.generate.title': 'Generate or compare variants',
    'tutorial.workspace.generate.body': 'Continue through the brief, then create one campaign or run a blind A/B experiment.',
    'tutorial.workspace.saved.title': 'Reuse successful work',
    'tutorial.workspace.saved.body': 'Open a saved campaign or load a starter brief to shorten your next workflow.',

    'tutorial.brandhub.name': 'Brand Hub setup',
    'tutorial.brandhub.intro.title': 'Your grounded brand memory',
    'tutorial.brandhub.intro.body': 'Store approved company, product, and source material so every generation can stay on brand.',
    'tutorial.brandhub.company.title': 'Create the company profile',
    'tutorial.brandhub.company.body': 'Add identity, positioning, audience, voice, colors, and a logo. Save the company before uploading assets.',
    'tutorial.brandhub.products.title': 'Add products and benefits',
    'tutorial.brandhub.products.body': 'Describe each offer, its target market, features, benefits, keywords, and reference images.',
    'tutorial.brandhub.assets.title': 'Upload approved knowledge',
    'tutorial.brandhub.assets.body': 'Documents are indexed for grounded answers; visual files become references for image and video production.',
    'tutorial.brandhub.generate.title': 'Generate grounded content',
    'tutorial.brandhub.generate.body': 'Choose an output, audience, and optional product to create content backed by the selected brand sources.',

    'tutorial.editor.name': 'Graphics Suite essentials',
    'tutorial.editor.toolbar.title': 'The editing workspace',
    'tutorial.editor.toolbar.body': 'The left toolbar selects assets and tools, the center shows the canvas, and the right panel exposes controls.',
    'tutorial.editor.assets.title': 'Choose a source asset',
    'tutorial.editor.assets.body': 'Open generated campaign artwork or upload an image from your device before editing.',
    'tutorial.editor.tools.title': 'Pick an editing tool',
    'tutorial.editor.tools.body': 'Transform, use a protected AI edit, adjust color, add text or shapes, manage layers, and export.',
    'tutorial.editor.canvas.title': 'Work directly on the canvas',
    'tutorial.editor.canvas.body': 'Preview changes, drag editable objects, and mark regions for crop or generative editing.',
    'tutorial.editor.properties.title': 'Fine-tune the active tool',
    'tutorial.editor.properties.body': 'The controls here change with the selected tool and preserve undoable editing history.',

    'tutorial.analytics.name': 'Analytics overview',
    'tutorial.analytics.intro.title': 'Measure campaign activity',
    'tutorial.analytics.intro.body': 'This page summarizes generation volume, AI quality, and reviewer feedback.',
    'tutorial.analytics.metrics.title': 'Track the headline metrics',
    'tutorial.analytics.metrics.body': 'Use these cards to monitor output volume, average quality, ratings, and review coverage.',
    'tutorial.analytics.patterns.title': 'Spot useful patterns',
    'tutorial.analytics.patterns.body': 'Strategy and platform breakdowns reveal which approaches your team uses most often.',

    'tutorial.results.name': 'Review campaign results',
    'tutorial.results.summary.title': 'Start with the campaign summary',
    'tutorial.results.summary.body': 'Review positioning, quality, inputs, timing, and save the result when it is ready to keep.',
    'tutorial.results.actions.title': 'Share, copy, or export',
    'tutorial.results.actions.body': 'Save before creating a client review link, or copy and print the complete campaign output.',
    'tutorial.results.tabs.title': 'Inspect every deliverable',
    'tutorial.results.tabs.body': 'Switch between creative assets, copy, strategy evidence, and the rollout plan.',
    'tutorial.results.detail.title': 'Review and refine the details',
    'tutorial.results.detail.body': 'Download media, copy individual fields, and regenerate supported content without rebuilding the campaign.',
    'tutorial.results.feedback.title': 'Close the feedback loop',
    'tutorial.results.feedback.body': 'Rate the result and record comments so quality trends appear in Analytics.',

    'tutorial.experiment.name': 'A/B experiment review',
    'tutorial.experiment.intro.title': 'Compare blind variants',
    'tutorial.experiment.intro.body': 'Experiments generate alternative approaches so you can choose using evidence instead of labels.',
    'tutorial.experiment.compare.title': 'Review the same criteria',
    'tutorial.experiment.compare.body': 'Compare creative direction, copy, and quality consistently before selecting a variant.',
    'tutorial.experiment.winner.title': 'Use the winning variant',
    'tutorial.experiment.winner.body': 'Promote the selected result into the main campaign workflow for saving, editing, and feedback.',

    'tutorial.settings.name': 'Preferences and tutorial help',
    'tutorial.settings.language.title': 'Change the interface language',
    'tutorial.settings.language.body': 'The tutorial and application copy update immediately when you select another supported language.',
    'tutorial.settings.theme.title': 'Choose light or dark mode',
    'tutorial.settings.theme.body': 'Tutorial cards, spotlight, borders, and controls adapt instantly with the application theme.',
    'tutorial.settings.notifications.title': 'Control notifications',
    'tutorial.settings.notifications.body': 'Choose whether save confirmations, errors, and product updates appear as toast messages.',
    'tutorial.settings.replay.title': 'Return to any tutorial',
    'tutorial.settings.replay.body': 'This list shows synchronized progress and lets you start, resume, or replay each product tour.',
  },
  de: {
    'tutorial.controls.progress': 'Schritt {current} von {total}',
    'tutorial.controls.back': 'Zurück',
    'tutorial.controls.next': 'Weiter',
    'tutorial.controls.finish': 'Fertig',
    'tutorial.controls.skip': 'Tutorial überspringen',
    'tutorial.controls.pause': 'Pausieren',
    'tutorial.controls.dismiss': 'Tutorial schließen',
    'tutorial.controls.resume': 'Tutorial fortsetzen',
    'tutorial.controls.restart': 'Neu starten',
    'tutorial.controls.replay': 'Wiederholen',
    'tutorial.controls.start': 'Starten',
    'tutorial.controls.unavailable': 'Noch nicht verfügbar',
    'tutorial.controls.closeLabel': 'Dieses Tutorial schließen',
    'tutorial.controls.cardLabel': 'Produkt-Tutorial',
    'tutorial.center.title': 'Geführte Tutorials',
    'tutorial.center.help': 'Wiederhole eine Produkttour oder setze ein pausiertes Tutorial fort.',
    'tutorial.center.complete': 'Abgeschlossen',
    'tutorial.center.paused': 'Pausiert',
    'tutorial.center.skipped': 'Übersprungen',
    'tutorial.center.dismissed': 'Geschlossen',
    'tutorial.center.active': 'In Bearbeitung',
    'tutorial.center.new': 'Nicht gestartet',
    'tutorial.center.loading': 'Tutorial-Fortschritt wird geladen…',
    'tutorial.center.contextRequired': 'Verfügbar, wenn diese Funktion angezeigt wird',
    'tutorial.center.restartAll': 'Alle Tutorials neu starten',

    'tutorial.landing.name': 'Produkteinführung',
    'tutorial.landing.hero.title': 'Willkommen bei AWN AdPulse',
    'tutorial.landing.hero.body': 'Verwandle Markenwissen in Strategie, Text, Bilder und Videos – in einem verbundenen Workspace.',
    'tutorial.landing.intro.title': 'Ein verbundenes Kreativsystem',
    'tutorial.landing.intro.body': 'Die Plattform vereint Markenkontext, Briefing, Produktion und Review in einem durchgängigen Ablauf.',
    'tutorial.landing.features.title': 'Entdecke die Kernfunktionen',
    'tutorial.landing.features.body': 'Die Module decken Markenwissen, Kampagnenerstellung, Kreativformate und messbare Qualität ab.',
    'tutorial.landing.workflow.title': 'Ein klarer Weg zum Launch',
    'tutorial.landing.workflow.body': 'Baue die Markenbasis auf, erstelle die Kampagne, verfeinere Assets und prüfe die Ergebnisse.',
    'tutorial.landing.contact.title': 'Hilfe vom Team erhalten',
    'tutorial.landing.contact.body': 'Fordere Zugang an, besprich die Einführung oder vereinbare eine geführte Demonstration.',

    'tutorial.workspace.name': 'Workflow im Kampagnen-Studio',
    'tutorial.workspace.intro.title': 'Dein Kampagnen-Workspace',
    'tutorial.workspace.intro.body': 'Erstelle ein fundiertes Briefing und eine vollständige Kampagne auf einer Seite.',
    'tutorial.workspace.brief.title': 'Ein fokussiertes Briefing in drei Schritten',
    'tutorial.workspace.brief.body': 'Der Assistent gruppiert Marke, Zielgruppe und Produktion in überschaubare Abschnitte.',
    'tutorial.workspace.brand.title': 'Schritt 1: Marke und Produkt',
    'tutorial.workspace.brand.body': 'Wähle ein Brand-Hub-Profil oder gib eine Marke manuell ein. Öffne den Schritt, um die Felder zu prüfen.',
    'tutorial.workspace.audience.title': 'Schritt 2: Zielgruppe und Nutzen',
    'tutorial.workspace.audience.body': 'Lege Zielgruppe, Kernnutzen, Angebot und visuelle Referenzen fest.',
    'tutorial.workspace.output.title': 'Schritt 3: Strategie und Ausgabe',
    'tutorial.workspace.output.body': 'Wähle Ziel, Ton, Plattform, Art Direction, KI-Modell und optional Video.',
    'tutorial.workspace.generate.title': 'Generieren oder Varianten vergleichen',
    'tutorial.workspace.generate.body': 'Schließe das Briefing ab und erstelle eine Kampagne oder ein blindes A/B-Experiment.',
    'tutorial.workspace.saved.title': 'Erfolgreiche Arbeit wiederverwenden',
    'tutorial.workspace.saved.body': 'Öffne gespeicherte Kampagnen oder lade eine Vorlage für den nächsten Ablauf.',

    'tutorial.brandhub.name': 'Brand Hub einrichten',
    'tutorial.brandhub.intro.title': 'Dein fundiertes Markengedächtnis',
    'tutorial.brandhub.intro.body': 'Speichere freigegebene Unternehmens-, Produkt- und Quelldaten für markentreue Ergebnisse.',
    'tutorial.brandhub.company.title': 'Unternehmensprofil erstellen',
    'tutorial.brandhub.company.body': 'Ergänze Identität, Positionierung, Zielgruppe, Ton, Farben und Logo. Speichere vor dem Upload.',
    'tutorial.brandhub.products.title': 'Produkte und Nutzen hinzufügen',
    'tutorial.brandhub.products.body': 'Beschreibe Angebot, Zielmarkt, Funktionen, Vorteile, Keywords und Referenzbilder.',
    'tutorial.brandhub.assets.title': 'Freigegebenes Wissen hochladen',
    'tutorial.brandhub.assets.body': 'Dokumente werden indiziert; visuelle Dateien dienen als Referenzen für Bild und Video.',
    'tutorial.brandhub.generate.title': 'Fundierte Inhalte generieren',
    'tutorial.brandhub.generate.body': 'Wähle Ausgabe, Zielgruppe und optional ein Produkt für Inhalte auf Basis deiner Quellen.',

    'tutorial.editor.name': 'Grundlagen der Grafik-Suite',
    'tutorial.editor.toolbar.title': 'Der Bearbeitungs-Workspace',
    'tutorial.editor.toolbar.body': 'Links wählst du Assets und Werkzeuge, in der Mitte liegt die Leinwand, rechts die Einstellungen.',
    'tutorial.editor.assets.title': 'Quell-Asset auswählen',
    'tutorial.editor.assets.body': 'Öffne ein Kampagnenmotiv oder lade vor der Bearbeitung ein eigenes Bild hoch.',
    'tutorial.editor.tools.title': 'Bearbeitungswerkzeug wählen',
    'tutorial.editor.tools.body': 'Transformiere, nutze KI-Edits, passe Farben an, ergänze Text oder Formen und exportiere.',
    'tutorial.editor.canvas.title': 'Direkt auf der Leinwand arbeiten',
    'tutorial.editor.canvas.body': 'Prüfe Änderungen, verschiebe Objekte und markiere Bereiche für Zuschnitt oder KI-Bearbeitung.',
    'tutorial.editor.properties.title': 'Aktives Werkzeug feinjustieren',
    'tutorial.editor.properties.body': 'Diese Einstellungen passen sich dem Werkzeug an und unterstützen einen rückgängig machbaren Verlauf.',

    'tutorial.analytics.name': 'Analyse-Überblick',
    'tutorial.analytics.intro.title': 'Kampagnenaktivität messen',
    'tutorial.analytics.intro.body': 'Diese Seite fasst Generierungsvolumen, KI-Qualität und Feedback zusammen.',
    'tutorial.analytics.metrics.title': 'Zentrale Kennzahlen verfolgen',
    'tutorial.analytics.metrics.body': 'Beobachte Volumen, durchschnittliche Qualität, Bewertungen und Review-Abdeckung.',
    'tutorial.analytics.patterns.title': 'Nützliche Muster erkennen',
    'tutorial.analytics.patterns.body': 'Aufteilungen nach Strategie und Plattform zeigen die häufigsten Ansätze deines Teams.',

    'tutorial.results.name': 'Kampagnenergebnisse prüfen',
    'tutorial.results.summary.title': 'Mit der Zusammenfassung beginnen',
    'tutorial.results.summary.body': 'Prüfe Positionierung, Qualität, Eingaben und Dauer und speichere das fertige Ergebnis.',
    'tutorial.results.actions.title': 'Teilen, kopieren oder exportieren',
    'tutorial.results.actions.body': 'Speichere vor einem Kundenlink oder kopiere und drucke die vollständige Kampagne.',
    'tutorial.results.tabs.title': 'Alle Ergebnisse untersuchen',
    'tutorial.results.tabs.body': 'Wechsle zwischen Assets, Texten, Strategiebelegen und Rollout-Plan.',
    'tutorial.results.detail.title': 'Details prüfen und verfeinern',
    'tutorial.results.detail.body': 'Lade Medien herunter, kopiere Felder und generiere unterstützte Inhalte gezielt neu.',
    'tutorial.results.feedback.title': 'Feedback-Kreislauf schließen',
    'tutorial.results.feedback.body': 'Bewerte das Ergebnis und erfasse Kommentare, damit Trends in den Analysen erscheinen.',

    'tutorial.experiment.name': 'A/B-Experiment prüfen',
    'tutorial.experiment.intro.title': 'Blinde Varianten vergleichen',
    'tutorial.experiment.intro.body': 'Experimente erzeugen Alternativen, die du evidenzbasiert statt nach Namen auswählst.',
    'tutorial.experiment.compare.title': 'Nach gleichen Kriterien prüfen',
    'tutorial.experiment.compare.body': 'Vergleiche Kreativrichtung, Text und Qualität einheitlich vor der Auswahl.',
    'tutorial.experiment.winner.title': 'Gewinnende Variante verwenden',
    'tutorial.experiment.winner.body': 'Übernimm das Ergebnis zum Speichern, Bearbeiten und Bewerten in den Hauptablauf.',

    'tutorial.settings.name': 'Einstellungen und Tutorial-Hilfe',
    'tutorial.settings.language.title': 'Oberflächensprache ändern',
    'tutorial.settings.language.body': 'Tutorial und Anwendungstexte aktualisieren sich sofort bei einer anderen Sprache.',
    'tutorial.settings.theme.title': 'Hellen oder dunklen Modus wählen',
    'tutorial.settings.theme.body': 'Karten, Spotlight, Rahmen und Steuerelemente passen sich sofort an.',
    'tutorial.settings.notifications.title': 'Benachrichtigungen steuern',
    'tutorial.settings.notifications.body': 'Lege fest, ob Speicherbestätigungen, Fehler und Updates als Hinweise erscheinen.',
    'tutorial.settings.replay.title': 'Jedes Tutorial erneut öffnen',
    'tutorial.settings.replay.body': 'Die Liste zeigt synchronisierten Fortschritt und erlaubt Start, Fortsetzen oder Wiederholen.',
  },
};

export function formatTranslation(template, values = {}) {
  return Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
    String(template || ''),
  );
}
